// FortnightlyReport.js
import React, { useEffect, useState } from 'react';
import '../css/Report.css';
import Navbar from './Navbar';
import { BaseUrl, reportSearch } from '../Services/Api';
import Spinner from '../helperComponents/Spinner';
import { useLocation, useNavigate } from "react-router-dom";

const Report = () => {
  const [reportData, setReportData] = useState(null);
  const [courseReportData, setCourseReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(0);
  const [rowData, setRowData] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // Check authentication and fetch user id
  useEffect(() => {
    document.title = 'Report';

    async function checkAuth() {
      try {
        const res = await fetch(`${BaseUrl}/me`, {
          method: "GET",
          credentials: "include",
        });

        if (res.ok) {
          const data = await res.json();

          if (data.user) {
            setUserId(data.user.id);
          } else {
            navigate('/');
          }
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error("Auth check failed", err);
        navigate('/');
      }
    }
    checkAuth();
  }, [navigate]);

  // Set rowData either from location or authenticated userId
  useEffect(() => {
    const locData = location.state?.rowData || 0;

    if (locData === undefined || locData === 0) {
      setRowData(userId);
    } else {
      setRowData(locData);
    }
  }, [location.state, userId]);

  // Fetch report data
  useEffect(() => {
    if (!rowData || rowData === 0) return;

    const fetchReport = async () => {
      setLoading(true);
      try {
        const response = await reportSearch(rowData);

        if (response?.status === "success") {
          setReportData(response.data[0]);
          setCourseReportData(response.courses_duration || []);
        } else {
          setReportData(null);
        }
      } catch (err) {
        console.error("Error fetching report:", err);
        setReportData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [rowData]);

  // Loading state
  if (loading) {
    return (
      <>
        <Navbar />
        <div className="fortnightly-report-body">
          <div className="fortnightly-report-container">
            <h2 className="fortnightly-report-title">Progress Tracking</h2>
            <Spinner />
          </div>
        </div>
      </>
    );
  }

  // Empty data state
  if (!reportData) {
    return (
      <>
        <Navbar />
        <div className="fortnightly-report-body">
          <div className="fortnightly-report-container">
            <h2 className="fortnightly-report-title">Progress Tracking</h2>
            <h2 className="fortnightly-report-title2">No Data Found</h2>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="fortnightly-report-body">
        <div className="fortnightly-report-container">
          <h2 className="fortnightly-report-title">Progress Tracking</h2>

          {/* User Info */}
          <table className="fortnightly-report-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Full Name</th>
                <th>Email ID</th>
                <th>Programme Name</th>
                <th>Registration Date</th>
                <th>Completion Date</th>
                <th>Total Time Spent</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{reportData.fullname}</td>
                <td>{reportData.email}</td>
                <td>{reportData.course_name}</td>
                <td>{reportData.purchased_date}</td>
                <td>{reportData.expiry_date}</td>
                <td>{reportData.totalTime}</td>
              </tr>
            </tbody>
          </table>

          {/* Course-wise Time Spent */}
          <table className="fortnightly-report-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Course Name</th>
                <th>Total Time Spent</th>
              </tr>
            </thead>
            <tbody>
              {courseReportData?.map((course, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{course.course_name}</td>
                  <td>{course.duration}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Unit Wise Progress */}
          {reportData.unit_details?.length > 0 && (
            <div className="fortnightly-report-card">
              <h3>{reportData.course_name}</h3>
              <table className="fortnightly-report-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Programme</th>
                    <th>Course Name</th>
                    <th>Assessment Test</th>
                    <th>Grade</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.unit_details.map((unit, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{unit.programme}</td>
                      <td>{unit.course_name}</td>
                      <td>
                        {unit.assessment_test
                          ? <span className="fortnightly-report-status fortnightly-report-completed">✔</span>
                          : <span className="fortnightly-report-status fortnightly-report-not-completed">✖</span>}
                      </td>
                      <td>
                        {unit.assessment_test && parseFloat(unit.assessment_test) > 0
                          ? <span className="fortnightly-report-status fortnightly-report-completed">{unit.assessment_test}</span>
                          : <span className="fortnightly-report-status fortnightly-report-not-completed">Not Completed</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        </div>
      </div>
    </>
  );
};

export default Report;
